import { IBridge } from "@multiweb/reactCore/bridge/api";
import { bridgeInstance } from "./Bridge";
import { saga } from "./saga";

// Nastavení ságy do bridge modulu. Nelze udělat přes import kvůli cyklické závislosti.
bridgeInstance.setSaga(saga);

export * from "@multiweb/reactCore/bridge/api";
export const bridge: IBridge = bridgeInstance;
